import axios from 'axios'


const verifyToken = async (token) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/login/auth/verifyToken',
        headers : { authorization : 'bearer '+token },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err;
        });
    return response;
};

export default verifyToken;